import { render, staticRenderFns } from "./ConfirmCard.vue?vue&type=template&id=8b0e4eea"
import script from "./ConfirmCard.vue?vue&type=script&lang=js"
export * from "./ConfirmCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports